import React, { useState, useEffect } from "react";
import AppLayoutWrapFull from "components/AppLayoutWrapFull";
import PageHeader from "components/PageHeader/PageHeader";
import Container from "components/Container/Container";
import PageHeaderActions from "components/PageHeader/components/PageHeaderActions/PageHeaderActions";
// import { setSelectedRows } from "helpers/utils";
import useFilterRows from "helpers/customHooks/useFilterRows";
import FullDataTable from "components/DataTable/FullDataTable";
import TableDefReports from "table-defs/TableDefReports";
import { connect, useSelector, useDispatch } from "react-redux";
import { withRouter } from "react-router-dom";
import { loadSitesAction, loadReportsAction, setPaginationAction, deleteReportAction, downloadReportAction } from "store/actions/Actions";
import AddReportModal from "./components/AddReportModal/AddReportModal";
import { setSelectedRows, toggleDropdowns, exportAsCSV } from "helpers/utils";
import ReactDOM from "react-dom";
import ConfirmationModal from "components/ConfirmationModal/ConfirmationModal";

const reportsList = [
    {
        key: '1',
        name: "Gap Analysis",
        type: "gap",
        acts: ["OSHA", "HIPAA"],
    },
    {
        key: '2',
        name: "Remediation Plans",
        type: "remediation",
        acts: ["OSHA", "HIPAA"],
    },
    {
        key: '3',
        name: "Task Manager Report",
        isOrgWide: true,
        type: "task",
        acts: ["OSHA", "HIPAA"],
    },
    {
        key: '4',
        name: "Risk Analysis Summary",
        type: "risk",
        acts: ["OSHA", "HIPAA"],
    },
    {
        key: '5',
        name: "IT Device Audit Summary",
        type: "device",
        acts: ["HIPAA"],
    },
    {
        key: '6',
        name: "Affiliate Report",
        type: "vendor",
        acts: ["HIPAA"],
    },
    {
        key: '7',
        name: "Training and Attestation Report",
        type: "attestation",
        acts: ["OSHA", "HIPAA"],
    },
    {
        key: '8',
        name: "Incident Summary",
        type: "incident",
        acts: ["OSHA", "HIPAA"],
    },
];

const Reports = props => {
    const dispatch = useDispatch();
    const DatatableReducer = useSelector((state) => state.DatatableReducer);

    const [state, setState] = useState({
        selectedRows: null,
        selected_sites: []
    });
    const [showModal, setShowModal] = useState(false);
    const [activeReg, setActiveReg] = useState('');

    useEffect(() => {
        if (DatatableReducer.datatable && DatatableReducer.datatable.dashboard && DatatableReducer.datatable.dashboard.activeReg) {
            setActiveReg(DatatableReducer.datatable.dashboard.activeReg);
        }
    }, [DatatableReducer.datatable]);

    useEffect(() => {
        if (activeReg && DatatableReducer.datatable && DatatableReducer.datatable.reports) {
            setFilters({
                ...DatatableReducer.datatable.reports.filters,
                regulatory_act: activeReg,
            });
        }
    }, [activeReg]);

    const { loadSitesAction, loadReportsAction, deleteReportAction, SitesReducer, ReportsReducer, downloadReportAction, setPaginationAction } = props;
    const noFilters = {
        text: "",
        type: "",
        "last-action": "",
        status: "",
        role: "",
        site: "",
        start: "",
        end: "",
        regulatory_act: activeReg,
        selected_sites: [],
        dateField: "created_at"
    };

    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const renderConfirmModal = () => {
        return ReactDOM.createPortal(
            <ConfirmationModal
                data={showConfirmModal}
                setShowModal={setShowConfirmModal}
            />,
            document.getElementById('modal-root'),
        );
    };

    useEffect(() => {
        if (!SitesReducer.sites) {
            loadSitesAction();
        }
    }, [SitesReducer.sites, loadSitesAction]);

    useEffect(() => {
        if (!ReportsReducer.reports && SitesReducer.sites) {
            loadReportsAction();
        }
    }, [ReportsReducer.reports, SitesReducer.sites, loadReportsAction]);

    const [filters, setFilters] = useState(
        (DatatableReducer.datatable && DatatableReducer.datatable.reports && DatatableReducer.datatable.reports.filters)
        ? DatatableReducer.datatable.reports.filters
        : noFilters);


    const setFilter = filterName => e => {
        setFilters({
            ...filters,
            [filterName]:
                e.target.type === "checkbox"
                    ? e.target.checked
                    : e.target.value || ((e.target && e.target.attributes && e.target.attributes.value && e.target.attributes.value.value) || '')
        });
        setPaginationAction({ dataType: 'reports', currentPage: 0 });
    };

    const [selectedReportIds, setSelectedReportIds] = useState(
        (DatatableReducer.datatable && DatatableReducer.datatable.reports && DatatableReducer.datatable.reports.selectedIds)
            ? DatatableReducer.datatable.reports.selectedIds
            : []);

    useEffect(() => {
        dispatch({
            type: 'SET_DATATABLE',
            payload: {
                datatable: {
                    reports: {
                        selectedIds: selectedReportIds,
                        filters,
                        selectedRows: state.selectedRows,
                        selected_sites: state.selected_sites,
                        rowsPerPage: (DatatableReducer.datatable && DatatableReducer.datatable.reports && DatatableReducer.datatable.reports.rowsPerPage)
                        ? DatatableReducer.datatable.reports.rowsPerPage
                        : 10,
                        currentPage: (DatatableReducer.datatable && DatatableReducer.datatable.reports && DatatableReducer.datatable.reports.currentPage)
                        ? DatatableReducer.datatable.reports.currentPage
                        : 0
                    },
                },
            },
        });
    }, [selectedReportIds, filters, state]);

    const filteredRows = useFilterRows(filters, ReportsReducer.reports);

    // const setFilter = filterName => e => {
    //     setFilters({
    //         ...filters,
    //         [filterName]: e.target.type === "checkbox" ? e.target.checked : e.target.value || ((e.target && e.target.attributes && e.target.attributes.value && e.target.attributes.value.value) || '')
    //     });
    // };

    const onChangeRowSelect = ({ selectedRows }) => {
        if (selectedRows !== state.selectedRows) {
            setState(s => ({ ...s, selectedRows }));
        }
    };

    const setDateFilter = filterName => value => {
        setFilters({ ...filters, [filterName]: value });
        setPaginationAction({ dataType: 'reports', currentPage: 0 });
    };

    const actDropdownRef = React.createRef();
    const siteDropdownRef = React.createRef();
    const chooseActionDropdownRef = React.createRef();
    const associatedSiteRef = React.createRef();
    const regDropdownRef = React.createRef();

    // const [selectedReportIds, setSelectedReportIds] = useState([]);

    const handleDelete = (ids) => {
        deleteReportAction(ids);
    };

    const handleView = ({ hash, file_type = 'pdf'}) => {
        if (file_type && hash) {
            downloadReportAction({ file_type, hash });
        }
    };

    const getSitesList = () => {
        try {
            const sitesList = SitesReducer.sites ? SitesReducer.sites.map(site => {
                return {
                    id: site.id,
                    siteName: site.name,
                    value: filters.selected_sites.includes(site.id) ? true : false
                }
            }) : [];
            sitesList.unshift({id: null, siteName: 'Org-wide report', value: filters.selected_sites.includes(undefined) });
            return sitesList;
        } catch (error) {
            console.log('error with site list', error);
        }
        return [];
    };

    const labels = () => (
        {
          id: {
            label: 'ID',
          },
          name: {
            label: 'TITLE',
          },
          regulatory_act: {
            label: 'REGULATORY',
          },
          siteName: {
            label: 'SITE',
          },
          date_from: {
            label: 'DATE FROM',
          },
          date_to: {
            label: 'DATE TO',
          },
          created_at: {
            label: 'CREATED',
          },
          status: {
            label: 'STATUS',
          },
        }
    );

    return (
        <AppLayoutWrapFull
            onClick={toggleDropdowns([
                associatedSiteRef,
                actDropdownRef,
                siteDropdownRef,
                chooseActionDropdownRef,
                // statusDropdownRef
            ])}        
        >
            <div id="modal-root"></div>
            <PageHeader showStats={true}>
                <PageHeaderActions
                    primaryButtonText="ADD REPORT"
                    primaryButtonHandler={() => setShowModal(!showModal)}
                    searchHandler={e => {
                        setFilters({ ...filters, text: e.target.value || "" });
                        setPaginationAction({ dataType: 'reports', currentPage: 0 });
                    }}
                    searchValue={filters.text}
                    chooseAction={[
                        {
                            actionName: "Export Selected",
                            actionHandler: () => {
                                const data = ReportsReducer.reports.filter((item) => selectedReportIds.map(i => i.id).includes(item.id));
                                const updatedData = data.map((item) => ({
                                    ...item,
                                    created_at: item.created_at ? item.created_at.substring(0,10) : '',
                                    date_from: item.date_from ? item.date_from.substring(0,10) : '',
                                    date_to: item.date_to ? item.date_to.substring(0,10) : ''
                                }));
                                exportAsCSV(updatedData, labels, 'reports.csv');
                            }
                        },
                        {
                            actionName: "Delete Selected",
                            actionHandler: () => {

                                const idCount = state.selectedRows.length;

                                if (idCount > 0) {
                                    setShowConfirmModal({
                                        title: 'Delete selected reports',
                                        question: idCount === 1 ? 
                                            `Are you sure you want to delete the selected report?` : 
                                            `Are you sure you want to delete ${idCount} selected reports?`,
                                        confirmAction: () => {
                                            handleDelete(state.selectedRows.map((item) => item.id));
                                        },
                                    });
                                } else {
                                    setShowConfirmModal({
                                        type: 'simple',
                                        title: 'Nothing selected',
                                        question: `Please select reports to be deleted.`,
                                    });
                                }
                            }
                        }
                    ]}
                    chooseActionDropdownRef={chooseActionDropdownRef}
                    site={{
                        onClick: (e) => {
                            if (e.target.type === 'checkbox') {
                                let selected_sites = filters.selected_sites.slice();
                                if (e.target.checked) {
                                    selected_sites.push(e.target.value);
                                } else {
                                    if (e.target.value === '') {
                                        selected_sites = selected_sites.filter(site => site !== undefined);
                                    } else {
                                        selected_sites = selected_sites.filter(site => site !== e.target.value);
                                    }
                                }
                                for(let i = 0; i < selected_sites.length; i++) {
                                    if (selected_sites[i] === '') {
                                        selected_sites[i] = undefined;
                                    }
                                }
                                setFilters({
                                    ...filters,
                                    site: selected_sites.length > 0 ? `Sites (${selected_sites.length})` : 'Site',
                                    selected_sites: selected_sites
                                });
                                setPaginationAction({ dataType: 'reports', currentPage: 0 });
                            }
                        },
                        sites: getSitesList(),
                    }}
                    siteDropdownRef={siteDropdownRef}
                    dateRange={{
                        onChangeStart: setDateFilter("start"),
                        onChangeEnd: setDateFilter("end")
                    }}
                    reg={{
                        onChange: setFilter("regulatory_act"),
                        options: ["All regulatory", "HIPAA", "OSHA"]
                    }}
                    regDropdownRef={regDropdownRef}
                    filters={filters}
                    resetFilters={() => {
                        setFilters(noFilters);
                        setPaginationAction({ dataType: 'reports', currentPage: 0 });
                    }}
                />
            </PageHeader>
            <Container wide fluid>
                {ReportsReducer.reports &&
                <FullDataTable
                    rowsData={filteredRows}
                    definitions={TableDefReports}
                    dataType="reports"
                    onChangeRowSelect={({ selectedRows }) => onChangeRowSelect({ selectedRows })}
                    setSelectedRows={setSelectedRows(["id"], setSelectedReportIds)}
                    customTableProps={{
                        selectedRows: state.selectedRows ? state.selectedRows : selectedReportIds,
                        pdf: ({ hash }) => handleView({ hash, file_type: 'pdf' }),
                        csv: ({ hash }) => handleView({ hash, file_type: 'csv' }),
                        delete: ({ id, name }) => {
                            setShowConfirmModal({
                                title: 'Delete the report',
                                question: `Are you sure you want to remove the report "${name}"`,
                                confirmAction: () => {
                                    handleDelete([id])
                                },
                            });
                        }
                    }}
                />
                }
                {showConfirmModal && renderConfirmModal()}
            </Container>

            {showModal ? (
                <AddReportModal
                    reportsList={reportsList}
                    setShowModal={setShowModal}
                    loadReportsAction={props.loadReportsAction}
                    // actDropdownRef={actDropdownRef}
                    // siteDropdownRef={siteDropdownRef}
                />
            ) : null}

        </AppLayoutWrapFull>
    );
};

const mapStateToProps = (state) => ({
    SitesReducer: state.SitesReducer,
    ReportsReducer: state.ReportsReducer
});

const mapDispatchToProps = {
    loadSitesAction,
    loadReportsAction,
    setPaginationAction,
    deleteReportAction,
    downloadReportAction,
};

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(Reports)
);
